module.exports = __webpack_public_path__ + "assets/img/headPortrait2.e23a2d92.png";